import axios from "axios";

const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL;
if (!configuredBackendUrl) throw new Error("REACT_APP_BACKEND_URL is required");

const configuredHost = new URL(configuredBackendUrl).hostname;
const currentHost = window.location.hostname;
const isLocalHost = currentHost === "localhost" || currentHost === "127.0.0.1";
const backendUrl = !isLocalHost && currentHost !== configuredHost
  ? window.location.origin
  : configuredBackendUrl;

export const api = axios.create({
  baseURL: `${backendUrl}/api`,
  withCredentials: true,
});

export const apiBaseUrl = `${backendUrl}/api`;